import { render, staticRenderFns } from "./IndicatorsHeader.vue?vue&type=template&id=568d34b4&scoped=true&"
import script from "./IndicatorsHeader.vue?vue&type=script&lang=js&"
export * from "./IndicatorsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d34b4",
  null
  
)

export default component.exports